export class cuentaverificada {
  // la llave primaria se debe de llamar id o UsuarioId (claseId)
  NumMsj: number;
  TxtMsj: string;
  cuenta: string;
  id: string;
  idcodigo: string;
}
